var widget_default = {
  "card": "V0eek",
  "link": "zDrDj",
  "container": "F5-Dy",
  "image": "H6u1v",
  "right": "lU2Vq",
  "cardLayout": "KFEaI",
  "content": "-fvCf",
  "title": "_5Iw5t",
  "subtitle": "_9ykcC",
  "button": "xCtLq",
  "button_disabled": "jlue6",
  "buttonText": "c0eMp",
  "slimLayout": "un6V2",
  "rtl": "OM-pi",
  "ltr": "gQ68H"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
